export const MIN_NAME_LENGTH = 2;

// NOTE: This is a unicode regex that matches:
//       Any valid unicode Letter as first character
//       Any unicode Letter/Number and space, dot or dash character after that
export const NAME_REGEX = /^\p{L}[\p{L}\p{N} .-]*$/u;
